var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header_content"},[_vm._m(0),_c('div',{staticClass:"header_right"},[_c('div',{staticClass:"right_content"},[_c('div',[_vm._v("欢迎您，"+_vm._s(_vm.username))]),_c('div',[_c('a',{staticClass:"logout",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.logout}},[_vm._v("退出")])])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('span',[_vm._v("后台管理系统")])])
}]

export { render, staticRenderFns }